window.addEventListener('popstate', () => {
    if (window.history.state?.overlayOpen) {
        window.history.back();
    }
});
